export enum ContactFormFoundFrom {
	LinkedIn = "LinkedIn",
	WebSearch = "WebSearch",
	Conference = "Conference",
	Recommendation = "Recommendation",
}
